export function getClosestElementFor (selector) {
  return function getSelfOrClosest (target) {
    if (target.matches(selector)) {
      return target
    }
    return target.closest(selector)
  }
}
